import {makeAutoObservable} from "mobx";

class VideoStore {
    list = [];


    constructor() {
        makeAutoObservable(this);
    }
}

class LiveStore {
    video = new VideoStore();
    list = [];
    currentIndex = 0;

    constructor() {
        makeAutoObservable(this)
    }
}

export default new LiveStore();